import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATE_CANCEL_PAYMENT_SYSTEM_API_URL,
  AFFILIATE_CANCEL_PAYMENT_SYSTEM_MUTATION_KEY,
  AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_QUERY_KEY,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';

export default function useCancelPaymentSystemMutation(): IContextMutationResult<void, Error, number> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATE_CANCEL_PAYMENT_SYSTEM_MUTATION_KEY],
    mutationFn: (id) => fetchPost<void>(
      AFFILIATE_CANCEL_PAYMENT_SYSTEM_API_URL,
      {},
      {
        permission: PAYMENT_SYSTEM_DETAILS_PERMISSIONS.UPDATE,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_QUERY_KEY] });
      displayPresetToast('removed');
    },
  });
}
